import { createContext, useEffect, useState, type ReactNode } from "react";
import { localStorageService } from "../services/localStorageService";
import i18n from "../utils/i18n";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DEFAULT_LANGUAGE, LANGUAGES } from "../utils/constants/languages";
import { appRoutes } from "../routes";
import { SettingsService } from "../services/settingsService";
import { Maintenance } from "../components/commons/maintenance/maintenance";

type Props = {
    children: ReactNode;
};

let langSelected =  localStorageService.get('lang') ?? import.meta.env.VITE_DEFAULT_LANG;

export const LanguageContext = createContext<any>(langSelected);

export function LanguageProvider({children}:Props){

    const [settings,setSettings] = useState<any|null>({});
    const [settingsLoading, setSettingsLoading] = useState(true);
    const {lang} = useParams();
    const navigate = useNavigate();
    const location =useLocation();

    useEffect(()=>{
        const [,,path='map'] = location.pathname.split('/');
        console.log(path,'path')
        document.body.className=`page-${path}`;
    },[location.pathname]);


    useEffect(()=>{
        SettingsService().getParams().then(
            (response:any)=>{
                setSettings(response.data)
            }
        )
        .catch((error:any) => {
            console.error('Error fetching data:', error);
        })
        .finally(()=>{
            setSettingsLoading(false);
        })
    
        const languagesCode =LANGUAGES.filter((lang)=>lang.enabled).map((langCode)=>langCode.code);
        
        if(typeof lang !== "string"){
             navigate(`${DEFAULT_LANGUAGE?.code}/not-found`);
            return
        }
        
        if(!languagesCode.includes(lang)){
            navigate(`/${DEFAULT_LANGUAGE?.code}/not-found`);
            return;
        }

        const appRouteChild = appRoutes.find((route)=>route.path=="/:lang")?.children?.map((child)=>child.path);
        const arrRoute =location.pathname.split('/');     
        const suffix= location.pathname.substring(arrRoute[1].length + 2 );

        if(!appRouteChild?.includes(suffix) && suffix!==''){
            navigate(`/${lang}/not-found`);
            return;
        }
        
        i18n.changeLanguage(lang);
        localStorageService.set("lang", lang);
    },[lang,navigate])
    

     //const [language,setLanguageState] = useState(lang);

     function setLanguage(newLang:any){

        const  locationLang= location.pathname.split('/')[1];
        if (newLang === locationLang) return;

        navigate(location.pathname.replace(`/${locationLang}`, `/${newLang}`));

     }
     if(settingsLoading){
        return null
     }


    return(
        <LanguageContext.Provider value={{language:lang,setLanguage,settings,settingsLoading}}>
        {settings?.maintenance_mode === true
            ? <Maintenance />
            : children
        }
        </LanguageContext.Provider>       
    )
}